module.exports = __webpack_public_path__ + "img/transfer.ce678401.svg";